export function sizeGuideUrl(anchor, baseUrl) {
  if (!anchor) return null;
  let url;
  try { url = new URL(anchor.getAttribute('href'), baseUrl); } catch { return null; }
  if (!['https:', 'http:'].includes(url.protocol)) return null;
  if (!/\.(png|jpe?g|webp|gif|avif|svg)$/i.test(url.pathname)) return null;
  const namedGuide = /size[\s_-]*(guide|chart)/i.test(`${url.pathname} ${anchor.textContent}`);
  return anchor.hasAttribute('data-onepass-size-guide') || namedGuide ? url.href : null;
}

class OnePassSizeGuide extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.dialog = this.querySelector('dialog');
    if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
    document.addEventListener('click', this.openGuide, { signal });
    this.querySelector('[data-size-close]').addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('click', (event) => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
    }, { signal });
    this.dialog.addEventListener('close', () => {
      this.querySelector('[data-size-image]').replaceChildren();
      if (this.trigger?.isConnected) this.trigger.focus();
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    if (this.dialog?.open) this.dialog.close();
  }

  openGuide = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest?.('.onepass-product-help a, .onepass-product-description a, a[data-onepass-size-guide]');
    const url = sizeGuideUrl(anchor, location.href);
    if (!url) return;
    event.preventDefault();
    this.trigger = anchor;
    const image = new Image();
    image.alt = this.querySelector('h2').textContent;
    image.hidden = true;
    const loading = this.querySelector('[data-size-loading]');
    const error = this.querySelector('[data-size-error]');
    loading.hidden = false;
    error.hidden = true;
    image.addEventListener('load', () => { loading.hidden = true; image.hidden = false; }, { once: true });
    image.addEventListener('error', () => { loading.hidden = true; error.hidden = false; }, { once: true });
    this.querySelector('[data-size-original]').href = url;
    this.querySelector('[data-size-image]').replaceChildren(image);
    this.dialog.showModal();
    image.src = url;
  };
}

if (!customElements.get('onepass-size-guide')) customElements.define('onepass-size-guide', OnePassSizeGuide);
